export default "__VITE_ASSET__DLrshkI9__"